import React from "react";
import PropTypes from "prop-types";
import { Wrapper, CustomisedTitle, CPButton } from "../../constants/common/StyledGlobalConstants";
import { Title, Body } from "@vds/typography";

const CPFallbackPage = ({ ariaLabel, windowSize, pageTitle, pageContent, buttonId, buttonHandler, buttonName, buttonAriaLabel }) => {
  return (
      <Wrapper
        display="flex"
        flexDirection="column"
        justifyContent={windowSize <= 679 ? "center" : ""}
        alignItems="center"
        height="100vh"
        marginLeft="1rem"
        marginRight="1rem"
        aria-label={ariaLabel}
      >
        <Wrapper paddingTop={windowSize <= 679 ? "" : "30vh"} aria-labelledby="page-title" width={windowSize <= 480 ? "100%" : "440px"}>
          <CustomisedTitle fontSize={"40px"} lineHeight="48px">
            <Title id="page-title" size="large">
              {pageTitle}
            </Title>
          </CustomisedTitle>
          <Wrapper marginTop={"16px"} marginBottom={"40px"} width="100%">
            <Body size="small" id="page-content">
              {pageContent}
            </Body>
          </Wrapper>
          <CPButton
            boxButton={true}
            buttonWidth={"100%"}
            height={"3rem"}
            id={buttonId}
            type="submit"
            onClick={() => buttonHandler()}
            aria-describedby="page-content"
            aria-label={buttonAriaLabel}
          >
            {buttonName}
          </CPButton>
        </Wrapper>
      </Wrapper>
  );
};
CPFallbackPage.defaultProps = {
  buttonHandler: () => {},
  buttonName: "",
  buttonId: "",
  pageContent: "",
  pageTitle: "",
  ariaLabel: "",
  windowSize: 0,
};

CPFallbackPage.propTypes = {
  ariaLabel: PropTypes.string,
  windowSize: PropTypes.number,
  pageTitle: PropTypes.string,
  pageContent: PropTypes.string,
  buttonId: PropTypes.string,
  buttonHandler: PropTypes.func,
  buttonName: PropTypes.string,
  buttonAriaLabel: PropTypes.string,
};

export default CPFallbackPage;